'use client';
import { Modal } from '@/components/Modal/Modal';
import useBrand from '@/hooks/useBrand';
import { ReactNode, useState } from 'react';
import { COOKIES, MENTION_LEGAL } from './messages';
import styles from './style.module.css';

export default function Footer() {
  const [openedModal, setOpenedModal] = useState(false);
  const [modalContent, setModalContent] = useState<ReactNode>(<></>);
  const brand = useBrand().get();
  const openMentionLegalModal = () => {
    setModalContent(MENTION_LEGAL[brand]);
    setOpenedModal(true);
  };
  const openCookiesModal = () => {
    setModalContent(COOKIES);
    setOpenedModal(true);
  };
  const closeModal = () => {
    setModalContent(<></>);
    setOpenedModal(false);
  };
  return (
    <div className={styles.footer}>
      <div className={styles.content}>
        <a className={styles.link} onClick={openMentionLegalModal}>
          Mentions légales
        </a>
        <a className={styles.link} onClick={openCookiesModal}>
          Cookies
        </a>
      </div>
      <Modal open={openedModal} onClose={closeModal}>
        {modalContent}
      </Modal>
    </div>
  );
}
